import { render } from "./B2bPageOrdersReceiveds.vue?vue&type=template&id=b6bef4ae&scoped=true&lang=pug"
import script from "./B2bPageOrdersReceiveds.vue?vue&type=script&lang=js"
export * from "./B2bPageOrdersReceiveds.vue?vue&type=script&lang=js"

import "./B2bPageOrdersReceiveds.vue?vue&type=style&index=0&id=b6bef4ae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6bef4ae"]])

export default __exports__